import Cookies from 'js-cookie';

export function getCookie(name) {
  //获取Token
  return Cookies.get(name);
}

export function seveCookie(name, token) {
  //存储数据到cookie里，有效期为4小时
  
    Cookies.set(
      name,
      token,
      // { expires: 4 / 24 }
    );
  
}

export function seveCookieHttps(name, token) {
  //存储数据到cookie里，有效期为4小时
  if (process.env.NODE_ENV == 'production') {
    Cookies.set(
      name,
      token,
      // { expires: 4 / 24 }
      //https 下才会有效
      {
        sameSite: 'None',
        secure: true
      }
    );
  } else{
    Cookies.set(
      name,
      token,
      // { expires: 4 / 24 }
    );
  }
}
export function removeCookie(name) {
  //删除cookie里的缓存
  Cookies.remove(name);
}